export default "__VITE_ASSET__BKImtkMn__"